import get from 'lodash/get';
import {RestApiService} from '@techsee/techsee-client-infra/lib/services/RestApiService';
import {SESSION_TAGS_LIMITS} from '@techsee/techsee-common/lib/constants/session-tags.constants';

export interface AvailableSessionTags {
    tags: string[];
    maxPerSession: number;
}

export interface ISessionTagsService {
    // The account-defined list of session tags an agent can attach, plus the per-session cap.
    getAvailableTags(accountId: string): Promise<AvailableSessionTags>;
}

export class SessionTagsService implements ISessionTagsService {
    private readonly _restApiService: RestApiService;

    constructor(apiUrl: string, getAuthToken: () => string) {
        this._restApiService = new RestApiService(apiUrl, getAuthToken);
    }

    async getAvailableTags(accountId: string): Promise<AvailableSessionTags> {
        const res: any = await this._restApiService.get(`/api/accountTags/${accountId}`);
        const data = (res && typeof res === 'object' && res.data) || (res && typeof res === 'object' ? res : {});

        const tags: string[] = (Array.isArray(data.sessionTags) ? data.sessionTags : [])
            .filter((t: any) => t && typeof t.value === 'string')
            .map((t: {value: string}) => t.value);

        // caps ride the same /api/accountTags response.
        const maxPerSession: number = get(data, 'caps.maxPerSession', SESSION_TAGS_LIMITS.maxPerSession);

        return {tags, maxPerSession};
    }
}
